import axios from 'axios';
import Cookies from 'js-cookie';
import { API, TOKEN, BACKEND_HOST } from '../config/api/index';
import { logOut } from '../redux/authentication/actionCreator';

const instance = axios.create({
	baseURL: BACKEND_HOST,
	timeout: 300000, // 5 minutes
	headers: {
		'Content-Type': 'application/json; charset=utf-8',
		'User-ID': 'sandbox@fastship.co',
		'Accept': 'application/json',
		'Access-Control-Allow-Origin': '*',
		Authorization: TOKEN ? `Bearer ${TOKEN}` : null,
	},
});

// Request Interceptor
instance.interceptors.request.use((config) => {
	const user = Cookies.getJSON('user');
	if (user?.userId) {
		config.headers.common['Cust-ID'] = user.userId;
	}
	return config;
});

// Response Interceptor
instance.interceptors.response.use(
	(response) => {
		console.log('Response Interceptor:', response.status);
		return response;
	},
	async (error) => {
		const originalRequest = error.config;

		// Log the error for debugging
		console.error('Response Interceptor Error:', error.response?.status || error.message);

		// Handle 404 errors
		if (error.response?.status === 404) {
			console.error('Resource not found:', error.config.url);
			return Promise.reject(error);
		}

		// Handle 401 errors (unauthorized) and retry the request
		if (error.response?.status === 401 && !originalRequest._retry) {
			console.log('Attempting to refresh token...');
			originalRequest._retry = true;

			try {
				// Attempt to refresh the token
				const response = await axios.post(`${BACKEND_HOST}${API.auth.login}`, {
					username: 'sandbox@fastship.co',
					secretKey: 'DeliveryAtUrFingerTips',
				}, {
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'User-ID': 'sandbox@fastship.co',
						'Accept': 'application/json',
						'Access-Control-Allow-Origin': '*',
					},
				});

				// Update the original request with the new token
				originalRequest.headers['Authorization'] = `Bearer ${response.data.data}`;
				return instance(originalRequest);
			} catch (refreshError) {
				console.error('Token refresh failed:', refreshError);
				// logOut(); // Uncomment if you want to log out the user on token refresh failure
				return Promise.reject(refreshError);
			}
		}

		// Reject other errors
		return Promise.reject(error);
	}
);

export default instance;